<script>
  export let minSpacing = "auto";
  export let fixed = false;
</script>

<div class:fixed style="flex-basis: {minSpacing};">
  <slot />
</div>

<style>
  div {
    flex-grow: 1 !important;
    flex-shrink: 1 !important;
    align-self: stretch;
  }
  div.fixed {
    flex-grow: 0 !important;
    flex-shrink: 0 !important;
  }
</style>
